const smtShared = {
  translucent: {
    bgColor: {
      default: 'rgba(255, 255, 255, 0.8)',
      _dark: 'rgba(26, 32, 44, 0.8)'
    }
  },
  text: {
    default: {
      default: 'gray.800',
      _dark: 'gray.400'
    },
    bright: {
      default: 'gray.600',
      _dark: 'gray.300'
    },
    /**
     * Brand-coloured TEXT, and only text. Surfaces, buttons, borders and icons
     * keep brand.500, which is the mark and must not move.
     *
     * brand.500 (#d345f0) as a glyph colour on the white body is 3.57:1 and
     * fails WCAG 2.1 1.4.3. brand.600 (#ba25d4) is 4.88:1 and passes. On the
     * dark body, brand.300 (#edabfc) is 9.19:1 where theme.600 was 4.07:1.
     */
    brand: {
      default: 'brand.600',
      _dark: 'brand.300'
    }
  },
  // This is the default color for the body background
  // and overrides chakra-body-bg
  body: {
    bgColor: {
      default: 'white',
      _dark: 'gray.800'
    }
  },
  scrollbar: {
    thumb: {
      bgColor: {
        default: 'gray.300',
        _dark: 'gray.700'
      },
      hover: {
        bgColor: {
          default: 'gray.400',
          _dark: 'gray.600'
        }
      }
    }
  }
};

export default smtShared;
